module.exports = __webpack_public_path__ + "img/headPic.f23f8a91.jpg";